<div class="delete-ayuda-dialog">
    <h2 mat-dialog-title class="dialog-title">
        <i class="ri-alert-line text-danger me-2"></i>
        Confirmar Eliminación
    </h2>

    <mat-dialog-content class="dialog-content">
        <p class="warning-message">
            ¿Está seguro de que desea eliminar la ayuda <strong>{{ data.ayuda.titulo }}</strong>?
        </p>

        <div class="ayuda-details">
            <div class="detail-item">
                <span class="detail-label">Título:</span>
                <span class="detail-value">{{ data.ayuda.titulo }}</span>
            </div>
            <div class="detail-item">
                <span class="detail-label">Tipo:</span>
                <span class="detail-value">{{ data.ayuda.tipo === 'video' ? 'Video YouTube' : 'Documento' }}</span>
            </div>
        </div>

        <div class="alert-warning">
            <i class="ri-information-line me-2"></i>
            <span>Esta acción no se puede deshacer. La ayuda será eliminada permanentemente del sistema.</span>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions class="dialog-actions">
        <button mat-button (click)="onCancel()" class="cancel-button">
            <i class="ri-close-line me-2"></i>
            Cancelar
        </button>
        <button mat-raised-button color="warn" (click)="onConfirm()" class="confirm-button">
            <i class="ri-delete-bin-line me-2"></i>
            Eliminar
        </button>
    </mat-dialog-actions>
</div>
